import React, { useState } from "react";
import SecureRoute from "../seguridad/secure-route";
import { Switch, useRouteMatch, Route } from "react-router-dom";
import { useStateValue } from "../../context/store";
import { makeStyles, CssBaseline, Grid } from "@material-ui/core";
import Header from "../header/Header";
import SubHeader from "../header/subHeader";
import LeftMenu from "../LeftMenu/LeftMenu";
import MainContent from "../MainContent/MainContent";
import Footer from "../footer/Footer";
import Requisitions from "../../pages/requisitions/requisitions";
import RequisitionForm from "../../pages/requisitions/requisitionForm";
import Rol from "../../pages/roles";
import Vacancies from "../../pages/vacancies/vacancies";
import VacanciesRH from "../../pages/vacancies/vacanciesRH";
import Profile from "../../pages/profiles/createProfile";
import FormUsers from "../../pages/users/userForm";
import Users from "../../pages/users/users";
import Regional from "../../pages/regional/regional";
import EditRegional from "../../pages/regional/editRegional";
import UserConfiguration from "../../pages/userConfiguration/index";
import Categories from "../../pages/categories/categories";
import CategoriesForm from "../../pages/categories/categoriesForm";
import Skills from "../../pages/skills/skills";
import SkillsForm from "../../pages/skills/skillsForm";
import Charges from "../../pages/charges/charges";
import ClasesContracts from "../../pages/clausesContracts";
import EditCharges from "../../pages/charges/editCharges";
import Position from "../../pages/position/position";
import EditPosition from "../../pages/position/editPosition";
import CreatePosition from "../../pages/position/createPosition";
import Home from "../../pages/Home";
import curriculum from "../../pages/curriculumVitae/curriculum";
import cvEditForm from "../../pages/curriculumVitae/cvEditForm";
import cvForm from "../../pages/curriculumVitae/cvForm";
import Postulates from "../../pages/usersPostulates";
import Contracts from "../../pages/contracts/contracts/contracts";
import contractTypeContainer from "../../pages/contracts/contractType/contractTypeContainer";
import SelectionStartProcess from "../../pages/usersPostulates/selectionStartProcess";
import ContractTypeConfiguration from "../../pages/contracts/contractType/contractTypeConfiguration";
import requisitionsManage from "../../pages/requisitions/requisitionsManage";
import NoMatchPage from "../noMatchPage/NoMatchPage";
import NotAuthorized from "../../pages/notAuthorized";
import ScrollToTop from "../../hooks/scrollTop";
import GenerationContracts from "../../pages/generationContracts/generationContracts";
import Notification from "../../pages/notifications/notification";
import Permissions from "../../pages/permissions/permissions";
import PermissionSearch from "../../pages/permissions/permissionSearch";
import Laboratory from "../../pages/laboratory/laboratory";
import LaboratoryForm from "../laboratory/laboratoryForm";
import EditLaboratory from "../laboratory/editLaboratoryForm";
import MedicalExams from "../../pages/exams/exams";
import CreateorderExam from "../../pages/exams/create-order-exam";
import Exams from "../../pages/medicalExam/exams";
import CollectiveService from "../../pages/collectiveServiceOrder/collectiveService";
import RegisterPregnant from "../pregnant/registerPregnant";
import Pregnants from "../../pages/pregnant/pregnants";
import EndowmentDelivery from "../../pages/endowmentDelivery/endowmentDelivery";
import GenerateEndowmentDelivery from "../../pages/endowmentDelivery/formEndowmentDelivery/generateEndowmentDelivery";
import RegisterRefundRecomendationsAt from "../../pages/refundRecomendationsAt/registerRefundRecomendationsAt";
import RefundRecomendationsAt from "../../pages/refundRecomendationsAt/refundRecomendationsAt";
import WorkCertificate from "../../pages/workCertificate/workCertificate";
import requisitionsView from "../../pages/requisitions/requisitionsView";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    height: "100%",
  },
  content: {
    flex: "1 1 auto",
    margin: "3%",
    minHeight: "80vh",
    marginTop: "85px",
  },
}));

const MainDashboard = (props) => {
  const classes = useStyles();
  const [{ breadCrumb }, dispatch] = useStateValue();
  const [isOpen, setOpen] = useState(true);
  const [stateHome, setStateHome] = useState("");
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open, breadCrumb) => (event) => {
    if (breadCrumb) {
      setState("left", false);
      dispatch({
        type: "SET_BREADCRUMB",
        breadCrumbText: breadCrumb,
        index: -1,
      });
      props.history.push("/dashboard/home");
    }
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleDrawerClose = () => setOpen(false);
  const contenValueHome = (x) => setStateHome(x);

  const { path } = useRouteMatch();

  const renderSubheader = () => {
    if (
      breadCrumb?.breadCrumbText === "Inicio" ||
      breadCrumb?.breadCrumbText === null
    ) {
      return null;
    } else {
      return <SubHeader />;
    }
  };

  return (
    <ScrollToTop>
      <Grid className={classes.root}>
        <CssBaseline />
        <Header
          toggleDrawer={toggleDrawer}
          isOpen={isOpen}
          contenValueHome={contenValueHome}
        />
        {renderSubheader()}
        <LeftMenu
          handleDrawerClose={handleDrawerClose}
          toggleDrawer={toggleDrawer}
          isOpen={state}
          stateHome={stateHome}
        />
        <MainContent>
          <Grid id="pageContainer" className={classes.content}>
            <Switch>
              <SecureRoute
                exact
                path={`${path}/contract/generate-contract/:idVacancie/:document/:numberDocument`}
                component={GenerationContracts}
              />
              <SecureRoute
                exact
                path={`${path}/contract/renew-contract/:idContract/:document/:numberDocument`}
                component={GenerationContracts}
              />
              <SecureRoute
                exact
                path={`${path}/contract/generate-contract`}
                component={GenerationContracts}
              />
              <SecureRoute
                exact
                path={`${path}/requisicion`}
                component={Requisitions}
                code="REQ"
              />
              <SecureRoute
                exact
                path={`${path}/requisicion-gestionar`}
                component={requisitionsManage}
                code="REQ_MANAGE"
              />
              <SecureRoute
                exact
                path={`${path}/requisicion-view`}
                component={requisitionsView}
                code="REQ_VIEWER"
              />
              <SecureRoute
                exact
                path={`${path}/requisicion/crear`}
                component={RequisitionForm}
                code="REQ"
              />
              <SecureRoute
                exact
                path={`${path}/requisicion/edit/:id`}
                component={RequisitionForm}
                code="REQ"
              />
              <SecureRoute
                exact
                path={`${path}/user`}
                component={Users}
                code="USU"
              />
              <SecureRoute
                exact
                path={`${path}/user/create`}
                component={FormUsers}
                code="USU"
              />
              <SecureRoute
                exact
                path={`${path}/rol`}
                component={Rol}
                code="ROL"
              />
              <SecureRoute
                exact
                path={`${path}/clauses-contracts`}
                component={ClasesContracts}
                code="FOR_CLA_CON"
              />
              <SecureRoute
                exact
                path={`${path}/vacancies`}
                component={Vacancies}
                code="VAC"
              />
              <SecureRoute
                exact
                path={`${path}/gestion-vacancies`}
                component={VacanciesRH}
                code="VAC_PRIV"
              />
              <SecureRoute
                exact
                path={`${path}/home`}
                component={Home}
                code="HOME"
              />
              <SecureRoute
                exact
                path={`${path}/profile`}
                component={Profile}
                code="PER_CAR"
              />
              <SecureRoute
                exact
                path={`${path}/regional`}
                component={Regional}
                code="REG"
              />
              <SecureRoute
                exact
                path={`${path}/regional/crear`}
                component={EditRegional}
                code="REG"
              />
              <SecureRoute
                exact
                path={`${path}/regional/editar/:id`}
                component={EditRegional}
                code="REG"
              />
              <SecureRoute
                exact
                path={`${path}/categorias`}
                component={Categories}
              />
              <SecureRoute
                exact
                path={`${path}/categorias/crear`}
                component={CategoriesForm}
              />
              <SecureRoute
                exact
                path={`${path}/categorias/editar/:id`}
                component={CategoriesForm}
              />
              <SecureRoute exact path={`${path}/skills`} component={Skills} />
              <SecureRoute
                exact
                path={`${path}/skills/crear`}
                component={SkillsForm}
              />
              <SecureRoute
                exact
                path={`${path}/skills/editar/:id`}
                component={SkillsForm}
              />
              <SecureRoute
                exact
                path={`${path}/cargos`}
                component={Charges}
                code="CAR"
              />
              <SecureRoute
                exact
                path={`${path}/cargos/crear`}
                component={EditCharges}
                code="CAR"
              />
              <SecureRoute
                exact
                path={`${path}/cargos/editar/:id`}
                component={EditCharges}
                code="CAR"
              />
              <SecureRoute
                exact
                path={`${path}/perfil-cargos`}
                component={Position}
                code="PER_CAR"
              />
              <SecureRoute
                exact
                path={`${path}/perfil-cargos/crear`}
                component={CreatePosition}
                code="CAR"
              />
              <SecureRoute
                exact
                path={`${path}/perfil-cargos/editar/:id`}
                component={EditPosition}
                code="PER_CAR"
              />
              <SecureRoute
                exact
                path={`${path}/hoja-vida`}
                component={curriculum}
              />
              <SecureRoute
                exact
                path={`${path}/hoja-vida/crear`}
                component={cvForm}
              />
              <SecureRoute
                exact
                path={`${path}/hoja-vida/editar`}
                component={cvEditForm}
              />
              <SecureRoute
                exact
                path={`${path}/users-postulates/:idVacancie`}
                component={Postulates}
              />
              <SecureRoute
                exact
                path={`${path}/users-postulates/:idVacancie/start-process/:personName/:statusPostulate/:chargeRequested/:personDocument/:personDocumentType/:postulateId`}
                component={SelectionStartProcess}
              />
              <SecureRoute
                exact
                path={`${path}/type-contracts`}
                component={contractTypeContainer}
                code="FOR_TIP_CON"
              />
              <SecureRoute
                exact
                path={`${path}/type-contracts/configuration/:contractTypeId/:contractTypeName`}
                component={ContractTypeConfiguration}
              />
              <SecureRoute
                exact
                path={`${path}/contracts`}
                component={Contracts}
                code="CON"
              />

              <SecureRoute
                exact
                path={`${path}/configuration`}
                component={UserConfiguration}
              />
              <SecureRoute
                exact
                path={`${path}/notifications/:notificationType/:idNotification`}
                component={Notification}
              />
              <SecureRoute
                exact
                path={`${path}/notifications`}
                component={Notification}
              />
              <SecureRoute
                exact
                path={`${path}/permissions`}
                component={Permissions}
              />
              <SecureRoute
                exact
                path={`${path}/permissionsSearch/:type`}
                component={PermissionSearch}
              />
              <SecureRoute
                exact
                path={`${path}/laboratory`}
                component={Laboratory}
                code='LAB'
              />
              <SecureRoute
                exact
                path={`${path}/laboratory/create`}
                component={LaboratoryForm}
                code='LAB'
              />
              <SecureRoute
                exact
                path={`${path}/laboratory/edit`}
                component={EditLaboratory}
                code='LAB'
              />
              <SecureRoute
                exact
                path={`${path}/medicalExams`}
                component={MedicalExams}
                code='EXAM_MED'
              />
              <SecureRoute
                exact
                path={`${path}/medicalExams/create`}
                component={CreateorderExam}
                code='EXAM_MED'
              />

              <SecureRoute
                exact
                path={`${path}/medicalExams`}
                component={Exams}
                code='EXAM_MED'
              />

              <SecureRoute
                exact
                path={`${path}/collective-service-order`}
                component={CollectiveService}
                code='SER_COL'
              />

              <SecureRoute
                exact
                path={`${path}/pregnant-record`}
                component={RegisterPregnant}
                code='MAT_LIC'
              />

              <SecureRoute
                exact
                path={`${path}/pregnant`}
                component={Pregnants}
                code='MAT_LIC'
              />

              <SecureRoute
                exact
                path={`${path}/endowment-delivery`}
                component={EndowmentDelivery}
                code='DOT'
              />
              <SecureRoute
                exact
                path={`${path}/endowment-delivery/create`}
                component={GenerateEndowmentDelivery}
                code='DOT'
              />
              <SecureRoute
                exact
                path={`${path}/refund-recomendation-record`}
                component={RegisterRefundRecomendationsAt}
                code='REF_REC'
              />
              <SecureRoute
                exact
                path={`${path}/refund-recomendation-search`}
                component={RefundRecomendationsAt}
                code='REF_REC'
              />

              <SecureRoute
                exact
                path={`${path}/work-certificate-search`}
                component={WorkCertificate}
              />
              <Route path={`${path}/forbidden`}>
                <NotAuthorized />
              </Route>
              <Route path="*">
                <NoMatchPage />
              </Route>
            </Switch>
          </Grid>
          <Footer />
        </MainContent>
      </Grid>
    </ScrollToTop>
  );
};

export default React.memo(MainDashboard);
